module.exports = __webpack_public_path__ + "static/media/paiQuizCustomerServiceQR.8db4ec3e.svg";